import React, { ReactElement, FunctionComponent, memo } from 'react'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import CardHeadlineFont from '../../Theme/Fonts/CardHeadline'
import { BasicCardHeadlineProps } from '..'
import { WebHeadlineType } from '../../Theme/Fonts/BasicText'
import LinkProps from '../../Link/LinkProps'
import BasicCardHeadline from '../HelperClass/BasicCardHeadline'
import InfoLabel from '../../BaseComponents/InfoLabel'

export type DefaultCardHeadlineProps = WebHeadlineType & {
    type: 'DEFAULT'
    hint?: never
    /** icon on the right */
    icon?: never
    /** small text on the right */
    selectableText?: never
    /** colors the corresponding image in black or white */
    tintColor?: 'WHITE' | 'onyx'
    /**
     * function that will be called when the item on the right is clicked
     * @TJS-type function
     */
    onRightItemPress?: never
    /**
     * function that will be called when the headline is clicked
     * @TJS-type function
     */
    onPress?: () => void
    /** href for linking if headline is clicked */
    href?: string
    /**decide between PlayerImage circled and default image with square shape */
    imageType?: 'DEFAULT' | 'PLAYER'
    /**to display an image on the left from the headline */
    imageUrl?: string
} & LinkProps &
    BasicCardHeadlineProps

const DefaultCardHeadlineComponent: FunctionComponent<DefaultCardHeadlineProps> = ({
    text,
    onPress,
    href,
    tintColor = 'onyx',
    webHeadlineType,
    textColor,
    backgroundColor = 'pearl',
    infoLabel,
    testID,
    webRel,
    imageUrl,
    imageType = 'DEFAULT',
}): ReactElement => {
    return onPress || href ? (
        <Touchable onPress={onPress} href={href} testID={testID} webRel={webRel}>
            <Grid noExpand horizontal centerVertical backgroundColor={backgroundColor}>
                <BasicCardHeadline
                    webHeadlineType={webHeadlineType}
                    imageUrl={imageUrl}
                    imageType={imageType}
                    text={text}
                    textColor={textColor}
                />
                <Grid noExpand horizontal centerVertical marginLeft={3} alignRight>
                    {infoLabel ? <InfoLabel infoLabel={infoLabel} marginRight={3} /> : null}
                    <FontelloIcon
                        textAlign="right"
                        name="scroll-right"
                        fontSize={15}
                        color={tintColor}
                    />
                </Grid>
            </Grid>
        </Touchable>
    ) : (
        <Grid testID={testID} noExpand horizontal centerVertical backgroundColor={backgroundColor}>
            <CardHeadlineFont numberOfLines={1} webHeadlineType={webHeadlineType} color={textColor}>
                {text}
            </CardHeadlineFont>
            {infoLabel ? <InfoLabel infoLabel={infoLabel} marginRight={3} /> : null}
        </Grid>
    )
}

export default memo(DefaultCardHeadlineComponent)
